import React from 'react';
import {connect} from "react-redux";
import ModalDialog from "../../../ui/ModalDialog/ModalDialog";
import {showLinkingDiscord} from "../../../store/modalsSlice";

const LinkDiscord = (props) => {
	const handleClose = () => {
		props.showLinkingDiscord(null);
	};

	const handleSubmit = () => {
		if( props.linkingDiscord )
			window.location = props.linkingDiscord;

		const now = new Date();
		now.setTime(now.getTime() + 3600 * 100);
		document.cookie = "discordLinkRedirect=/alerts; expires=" + now.toUTCString() + "; path=/";

		handleClose();
	};

	return (
		<ModalDialog
			open={!!props.linkingDiscord}
			handleClose={handleClose} handleSubmit={handleSubmit} title='Link Discord'
			style={{height: '100%'}} submitString='Link Discord Account'
		>
			<p>To create custom spawn alerts, please link the Discord account you'd like to receive the alerts on.</p>
		</ModalDialog>
	);
};

const mapStateToProps = (state) => {
	return {
		linkingDiscord: state.modals.linkingDiscord
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		showLinkingDiscord: (val) => dispatch(showLinkingDiscord(val))
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(LinkDiscord);